import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const jobTypesApi = createApi({
  reducerPath: "jobTypesApi",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["JobType"],

  endpoints: (builder) => ({

    // 🟩 Get all job types (with optional search, pagination, and sorting)
    getAllJobTypes: builder.query({
      query: ({ pageno = 1, search, sort } = {}) => {
        let url = `/contractor/job-types?pageno=${pageno}`;
        if (search) url += `&search=${search}`;
        if (sort) url += `&sort=${sort}`;
        return { url, method: "GET" };
      },
      providesTags: ["JobType"],
      transformResponse: (response) => response?.body || response,
    }),

    getJobTypeById: builder.query({
      query: (id) => ({
        url: `/contractor/job-types/${id}`,
        method: "GET",
      }),
      providesTags: ["JobType"],
      transformResponse: (response) => response?.body || response,
    }),

    addJobType: builder.mutation({
      query: ({ data, role }) => ({
        url: `/${role}/job-type`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["JobType"],
    }),

    updateJobType: builder.mutation({
      query: ({ id, data, role }) => ({
        url: `/${role}/job-type/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["JobType"],
    }),

    deleteJobType: builder.mutation({
      query: ({ id, role }) => ({
        url: `/${role}/job-type/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["JobType"],
    }),
    getDefaultJobTypes: builder.query({
      query: () => {
        let url = `/contractor/job-types/default`;
        return { url, method: "GET" };
      },
      providesTags: ["JobType"],
      transformResponse: (response) => response,
    }),
    quoteActionByToken: builder.query({
      query: ({ action, token }) => ({
          url: `/contractor/job/quote/action/token`,
          method: 'GET',
          params: { action, token },
      }),

     }),
    getQuoteInfoByToken: builder.query({
        query: (token) => ({
          url: `/contractor/job/quote/info/token`,
          method: 'GET',
          params: { token },
      }),
      transformResponse: (response) => response?.body || response,
      })
  }),
});

export const {
  useGetAllJobTypesQuery,
  useGetJobTypeByIdQuery,
  useAddJobTypeMutation,
  useUpdateJobTypeMutation,
  useDeleteJobTypeMutation,
  useGetDefaultJobTypesQuery, 
  useQuoteActionByTokenQuery,
  useGetQuoteInfoByTokenQuery,
} = jobTypesApi;
